import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import ScheduledMessagesAPI from '../../api/scheduledMessages';

export const state = {
  records: [],
  meta: {
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
  },
  uiFlags: {
    isFetching: false,
    isCreating: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getMeta(_state) {
    return _state.meta;
  },
  getAllScheduledMessages(_state) {
    return _state.records;
  },
  getScheduledMessagesByConversationId: _state => conversationId => {
    return _state.records.filter(
      record => record.conversation_id === conversationId
    );
  },
};

export const actions = {
  get: async function getScheduledMessages({ commit }, page = 1) {
    commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isFetching: true });
    try {
      const response = await ScheduledMessagesAPI.get({ page });
      commit(types.SET_SCHEDULED_MESSAGES, response.data.payload);
      commit(types.SET_SCHEDULED_MESSAGES_META, response.data.meta);
    } finally {
      commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isFetching: false });
    }
  },
  create: async function createScheduledMessage(
    { commit },
    { conversationId, ...data }
  ) {
    commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isCreating: true });
    try {
      const response = await ScheduledMessagesAPI.create(conversationId, data);
      commit(types.ADD_SCHEDULED_MESSAGE, response.data);
      return response.data;
    } finally {
      commit(types.SET_SCHEDULED_MESSAGE_UI_FLAG, { isCreating: false });
    }
  },
  fetchByConversation: async ({ commit }, conversationId) => {
    const response =
      await ScheduledMessagesAPI.getByConversation(conversationId);
    response.data.payload.forEach(message =>
      commit(types.SET_SCHEDULED_MESSAGE, message)
    );
  },
  update: async ({ commit }, { conversationId, id, ...data }) => {
    const response = await ScheduledMessagesAPI.update(
      conversationId,
      id,
      data
    );
    commit(types.EDIT_SCHEDULED_MESSAGE, response.data);
    return response.data;
  },
  cancel: async ({ commit }, { conversationId, id }) => {
    const response = await ScheduledMessagesAPI.cancel(conversationId, id);
    commit(types.EDIT_SCHEDULED_MESSAGE, response.data);
  },
  retry: async ({ commit }, { conversationId, id }) => {
    const response = await ScheduledMessagesAPI.retry(conversationId, id);
    commit(types.EDIT_SCHEDULED_MESSAGE, response.data);
  },
};

export const mutations = {
  [types.SET_SCHEDULED_MESSAGE_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.ADD_SCHEDULED_MESSAGE]: MutationHelpers.create,
  [types.SET_SCHEDULED_MESSAGE]: MutationHelpers.setSingleRecord,
  [types.SET_SCHEDULED_MESSAGES]: MutationHelpers.set,
  [types.SET_SCHEDULED_MESSAGES_META](_state, meta) {
    _state.meta = {
      currentPage: Number(meta.current_page),
      totalPages: meta.total_pages,
      totalCount: meta.total_count,
    };
  },
  [types.EDIT_SCHEDULED_MESSAGE]: MutationHelpers.update,
  [types.DELETE_SCHEDULED_MESSAGE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
